const appConfig = {
  backendApiUrl: process.env.REACT_APP_BACKEND_URL || "",
};

export const getBackendApiUrl = () => appConfig.backendApiUrl.replace(/\/$/, "");

export default appConfig;
